/**
 * Friendly, title-cased names for the item kinds.
 *
 * Lived inside InspectorPanel.tsx until the item context menu needed the
 * same map for its header (2026-08-09). Two copies of a kind->label table is
 * how "Line 6 Helix" in one surface becomes "PRESETCHANGE" in another, so it
 * is one module both import.
 */

/** Falls back to the raw kind (upper-cased) for anything not listed. */
const KIND_LABELS: Record<string, string> = {
  button: 'Button',
  buttongrid: 'Button Grid',
  lfo: 'LFO',
  sequencer: 'Sequencer',
  streamdeck: 'Stream Deck',
  macro: 'Macro',
  statusLed: 'Status LED',
  fader: 'Fader',
  radial: 'Radial',
  label: 'Label',
  xypad: 'XY Pad',
  timelineLauncher: 'Timeline Launcher',
  piano: 'Piano',
  transpose: 'Transpose',
  capo: 'Capo',
  // Both full-row forms of an Ableton Control are named for the palette tile
  // they now come from (DEC-291): the operator added an Ableton Control, and
  // the Inspector's Layout row says which one and in what form.
  recQuant: 'Ableton Control',
  abletonRow: 'Ableton Control',
  sceneCopy: 'Scene Copy/Paste',
  wavesAutotune: 'Waves Autotune',
  mixer: 'Mixer',
  // Both Helix tiles were reading as raw kinds ("PRESETCHANGE") in the panel
  // heading. Named for the device, matching their palette tiles.
  presetChange: 'Line 6 Helix',
  snapshotChange: 'Helix Snapshot',
  display: 'Display',
  // Lighting (2026-09-17). Named for what the operator wants to DO, per the
  // suite ethos: "Light Colour", never "DMX Set State". The word DMX appears
  // nowhere an operator has to read it, which is DEC-014's capability moat
  // showing up in the vocabulary.
  lightColor: 'Light Colour',
  lightLevel: 'Light Level',
  lightFx: 'Light FX',
  blackout: 'Blackout',
  opvisualTrigger: 'OPVisual Trigger',
  opvisualGrid: 'OPVisual Grid',
  audioPads: 'Audio Pads',
  // Missing until 2026-10-10: the Inspector's head read "RIGSTATEBUTTON".
  // The palette's own name for it.
  rigStateButton: 'Rig State',
};

export function kindLabel(kind: string): string {
  return KIND_LABELS[kind] ?? kind.toUpperCase();
}
